import { React, useState, useEffect } from 'react';
import TOPBAR from "../../components/TopBar";
import SEARCHBAR from "../../components/SeachBar";
import MENUBAR from "../../components/Menu";
import FOOTER from "../../components/Footer";
import { Helmet } from 'react-helmet';





export default function Warranty() {

    const currentLink = window.location.href;
    const url = new URL(currentLink);
    const updatedUrl = url.toString();
    
    const [isHidden, setIsHidden] = useState(false);
    const [cartItems, setCartItems] = useState("");
    const [showMenuSide, setShowMenuSide] = useState("");

    useEffect(() => {
        setTimeout(() => {
            setIsHidden(true);
        }, 2000);
    }, []);

    useEffect(() => {
        const storedCartItems = localStorage.getItem('totalCartItems');
        if (storedCartItems) {
            const parsedCartItems = JSON.parse(storedCartItems);
            const numCartItems = Object.values(parsedCartItems);
            const sum = numCartItems.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            setCartItems(sum);
        }
        setTimeout(() => {
            setIsHidden(true);
        }, 2000);

    }, []);


    const setValueMenuSideBar = (value) => {
        setShowMenuSide(value)
    }

    return (
        <>

            <Helmet>
                <title>Terms and Conditions</title>
                <meta name="description" content='All products carry the manufacturer’s warranty policy.' />
                <link rel="canonical" href={updatedUrl} />
            </Helmet>

            <TOPBAR isHidden={isHidden} />
            <SEARCHBAR setValueMenuSideBar={setValueMenuSideBar} cartItemsdata={cartItems} />
            <MENUBAR showMenuSide={showMenuSide} setValueMenuSideBar={setValueMenuSideBar} />

            <div className="agreement-container" style={{ padding: '40px 20px', maxWidth: '900px', margin: '0 auto', lineHeight: '1.8', fontFamily: 'Roboto, sans-serif' }}>
                <h1 style={{ fontSize: '28px', marginBottom: '30px', fontWeight: '600', fontFamily: 'Roboto, sans-serif' }}>Customer Agreement</h1>

                <section style={{ marginBottom: '30px' }}>
                    <h2 style={{ fontSize: '22px', fontWeight: '600', marginBottom: '15px', fontFamily: 'Roboto, sans-serif' }}>1. Non-Disparagement & Non-Defamation Clause</h2>
                    <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', fontFamily: 'Roboto, sans-serif' }}>
                        <strong>1.1</strong> Customer shall not make any oral or written statement, publicly or privately, that is intended to disparage, defame, malign, or otherwise harm the reputation, business interests, or services of A Quality Tire LLC / Extreme Wheels, its owners, employees, or affiliates.
                    </p>
                    <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', fontFamily: 'Roboto, sans-serif' }}>
                        <strong>1.2</strong> This includes, but is not limited to, statements made on social media, online review platforms, blogs, forums, or any other public medium.
                    </p>
                    <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', fontFamily: 'Roboto, sans-serif' }}>
                        <strong>1.3</strong> This clause shall not apply to any truthful statement required to be made by law, in response to a court order, or to a government agency.
                    </p>
                    <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', fontFamily: 'Roboto, sans-serif' }}>
                        <strong>1.4</strong> Customer further agrees not to encourage, solicit, or instruct any third party to make or publish any statements that would be considered defamatory, slanderous, or disparaging against A Quality Tire LLC / Extreme Wheels. Any defamation carried out indirectly through another party shall be considered a breach of this agreement.
                    </p>
                </section>

                <section style={{ marginBottom: '30px' }}>
                    <h2 style={{ fontSize: '22px', fontWeight: '600', marginBottom: '15px', fontFamily: 'Roboto, sans-serif' }}>2. Non-Disclosure Agreement (NDA)</h2>
                    <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', fontFamily: 'Roboto, sans-serif' }}>
                        <strong>2.1</strong> Customer agrees not to disclose any proprietary, confidential, or sensitive information related to A Quality Tire LLC / Extreme Wheels, including but not limited to customer data, pricing, internal processes, business plans, and trade secrets.
                    </p>
                    <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', fontFamily: 'Roboto, sans-serif' }}>
                        <strong>2.2</strong> This confidentiality obligation remains in effect both during and after any professional or commercial relationship between the parties.
                    </p>
                    <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', fontFamily: 'Roboto, sans-serif' }}>
                        <strong>2.3</strong> Disclosure is permitted only with prior written consent or as required by law.
                    </p>
                </section>

                <section style={{ marginBottom: '30px' }}>
                    <h2 style={{ fontSize: '22px', fontWeight: '600', marginBottom: '15px', fontFamily: 'Roboto, sans-serif' }}>3. Hold Harmless Agreement</h2>
                    <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', fontFamily: 'Roboto, sans-serif' }}>
                        <strong>3.1</strong> Customer agrees to indemnify, defend, and hold harmless A Quality Tire LLC / Extreme Wheels, its owners, agents, officers, and employees from any and all claims, liabilities, damages, losses, and expenses (including reasonable attorneys' fees) arising out of or in any way connected with:
                    </p>
                    <ul style={{ marginLeft: '30px', marginBottom: '12px', fontSize: '16px', fontFamily: 'Roboto, sans-serif' }}>
                        <li>Any breach of this Agreement;</li>
                        <li>Any act of defamation or disparagement made by Customer or by third parties acting on their behalf;</li>
                        <li>Any misuse or misrepresentation involving A Quality Tire LLC / Extreme Wheels services or products.</li>
                    </ul>
                </section>

                <section style={{ marginBottom: '30px' }}>
                    <h2 style={{ fontSize: '22px', fontWeight: '600', marginBottom: '15px', fontFamily: 'Roboto, sans-serif' }}>4. General Provisions</h2>
                    <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', fontFamily: 'Roboto, sans-serif' }}>
                        <strong>4.1</strong> This Agreement shall be governed by and construed in accordance with the laws of the State of Arizona.
                    </p>
                    <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', fontFamily: 'Roboto, sans-serif' }}>
                        <strong>4.2</strong> This Agreement constitutes the entire agreement between the parties regarding the subject matter herein and supersedes any prior understanding or representation.
                    </p>
                    <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '400', fontFamily: 'Roboto, sans-serif' }}>
                        <strong>4.3</strong> If any provision of this Agreement is found to be unenforceable, the remaining provisions shall continue in full force and effect.
                    </p>
                </section>
            </div>

            < FOOTER />
        </>

    )
}
